import axios from 'axios'
import store from '@/store'
let api = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL || 'http://44.225.51.150:4004'
})

api.interceptors.request.use(request => {
    //add authorization header with jwt token to each request
    let user = store.state.user.user
    if (user && user.token) {
        request.headers['Authorization'] = `Bearer ${user.token}`
    }
    request.responseType='arraybuffer'
    return request
})

api.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.reject(error)
})

export default api